(function() {
  var Base,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Base = App.loadClass('core::reports/BaseOutput');

  exports.DetailOutput = (function(superClass) {
    extend(DetailOutput, superClass);

    function DetailOutput(parent, dialog, width, dtOpts, auxOpts) {
      var defOpts;
      if (width == null) {
        width = 'auto';
      }
      if (dtOpts == null) {
        dtOpts = {};
      }
      if (auxOpts == null) {
        auxOpts = {};
      }
      defOpts = {
        bPaginate: true,
        bServerSide: true,
        bProcessing: true,
        iDisplayLength: 50,
        fnServerParams: (function(_this) {
          return function(aoData) {
            return aoData.push({
              name: 'query',
              value: ko.toJSON(_this.parent.filters)
            });
          };
        })(this),
        fnInitComplete: function() {
          return this.fnAdjustColumnSizing(false);
        },
        sDom: "<'row-fluid'<'span8'l>r>t<'row-fluid'<'span8'p>>",
        bScrollCollapse: true,
        sPaginationType: 'bootstrap'
      };
      dtOpts = $.extend(defOpts, dtOpts);
      DetailOutput.__super__.constructor.call(this, parent, dialog, width, dtOpts, auxOpts);
    }

    return DetailOutput;

  })(Base);

}).call(this);
